import script from "./device-map.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-map.vue?vue&type=script&lang=ts&setup=true"

import "./device-map.vue?vue&type=style&index=0&id=d911a71e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d911a71e"]])

export default __exports__